import { render } from "./Success_kPay.vue?vue&type=template&id=ab5a66c4"
import script from "./Success_kPay.vue?vue&type=script&lang=js"
export * from "./Success_kPay.vue?vue&type=script&lang=js"

import exportComponent from "D:\\curProject\\newTrip\\client\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__